import { Inject, Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
declare global {
  interface Window { __env: any; }
}


@Injectable()
export class ConfigService {

  private config: Object;


  constructor(private http: Http) {
  }

  /**
   * Use to get the data found in the second file (config file)
   */
  public getConfig(key: any) {
    return this.config[key];
  }

  /**
   * This method:
   *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
   *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
   */
  public load() {
    let that = this;

    return new Promise((resolve, reject) => {
      let request: any = null;
      let apiUrl = environment.apiUrl;
      let configFile = environment.configFile;
      //console.log("apiUrl=" + apiUrl);
      //console.log("configFile=" + configFile);
      request = this.http.get(apiUrl);
      request
        .map(res => res.text())
        .catch((error: any) => {
          console.error('Error reading service url');
          resolve(error);
          return Observable.throw(error.json().error || 'Server error');
        })
        .subscribe((responseData: any) => {
          //console.log('service url '+responseData);
          localStorage.setItem('server', responseData);
          request = this.http.get(configFile);

          request
            .map(res => res.json())
            .catch((error: any) => {
              console.error('Error reading tpl configuration file');
              resolve(error);
              return Observable.throw(error.json().error || 'Server error');
            })
            .subscribe((responseData: any) => {
              that.config = responseData;

              localStorage.setItem('config', JSON.stringify(that.config));
              resolve(true);
            });
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/config.service.ts